import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

import { Checkbox } from "semantic-ui-react";

import WithFormField from "../WithFormField";

export function ControlledCheckbox({
  name,
  defaultValue,
  text,
  required,
  errorMessage,
  ...props
}) {
  const { field } = useController({
    name: name,
    defaultValue: defaultValue,
    rules: { required: { value: required, message: errorMessage } },
  });

  return (
    <React.Fragment>
      <Checkbox
        toggle
        checked={field.value}
        label={text}
        onChange={(_, { checked }) => {
          return field.onChange(checked);
        }}
        {...props}
      />
      {required && (
        <span style={{ color: "#BF3333", fontWeight: "bold" }}>*</span>
      )}
    </React.Fragment>
  );
}

ControlledCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.bool,
  text: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
};

ControlledCheckbox.defaultProps = {
  defaultValue: false,
  text: "",
  required: false,
  errorMessage: "",
};

export default WithFormField(ControlledCheckbox);
